import { BoxSpg, DividerSpg, FormSection, GridContainer, GridItem, InputFormField } from "@duosoftbg/nacid-components";
import { Alert, Button, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import React from "react";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";

const AdditionalDocStepDetails = ({ fullSchema, formalSchema, methods, onSubmit }) => {
  const { t } = useTranslation();
  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
          })}
        >
          <FormSection label={"t.additionalDoc.details"}>
            <GridContainer>
              <GridItem sm={12} md={12}>
                <Alert severity={"info"}>{t("m.additionalDoc.details.description")}</Alert>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={3}>
              <GridItem sm={12} md={12}>
                <InputFormField
                  required={false}
                  fieldName={"entryNumber"}
                  labelCode={"l.additionalDoc.entryNumber.with.format"}
                />
              </GridItem>
              <GridItem sm={12} md={12}>
                <InputFormField
                  required={false}
                  fieldName={"additionalInfo"}
                  labelCode={"l.additionalDoc.additionalInfo"}
                />
              </GridItem>
            </GridContainer>
          </FormSection>

          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default AdditionalDocStepDetails;
